import styled from 'styled-components';

export const Header = styled.div`
  box-sizing: border-box;
  padding: 0 12px;
  margin: 12px 0;
  justify-content: space-between;
  align-items: center;
  grid-auto-flow: column;
  display: grid;
`;

export const Title = styled.span`
  display: block;
`;
